<template>
  <div class="ml-4 mr-4">
    <div v-if="type === 'create'">
      <div class="row py-3 align-items-center">
        <div class="col company-h1">
          <button type="button"
                  class="btn btn-back"
                  @click="setCompanyStep('companies-settings')"
          />
          Create Company
        </div>
        <div class="col text-right"
             v-if="$_can('companies.prices.store')"
        >
          <button class="btn btn-primary ld-ext-right"
                  type="button"
                  @click="saveProfile"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="buttonDisabled"
          >
            Save
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
      <companies-steps-menu type="create" />
    </div>
    <div v-if="type === 'edit'">
      <div class="row py-3 align-items-center company-header">
        <div class="col-4">
          <h2 class="company-h1 mr-3">
            <button type="button"
                    class="btn btn-back"
                    @click="$router.push('/companies')"
            />
            {{ company.name }}
          </h2>
          <template v-if="company.status">
            <span v-if="company.status.name === 'Active'"
                  :class="'btn-status btn-active'"
            >{{ company.status.name }}</span>
            <span v-if="company.status.name === 'Inactive'"
                  :class="'btn-status btn-closed'"
            >{{ company.status.name }}</span>
            <span v-if="company.status.name === 'Setup Incomplete'"
                  :class="'btn-status btn-ncover info-company'"
            >{{ company.status.name }}
              <div class="btn btn-link p-0 tippy-popup tippy-info"
                   @mouseover="showTooltipPrefix = true"
                   @mouseout="showTooltipPrefix = false"
              >
                <i class="fa fa-info-circle" />
              </div>
              <div class="popover tippy-info-popover"
                   v-if="showTooltipPrefix"
              >
                Setup incomplete is present when the company doesn't have one or more of the following: move sizes,
                arrival windows, merchant account, rates and coverage.
              </div>
            </span>
          </template>
        </div>
        <div class="col-8 d-flex align-items-center justify-content-end">
          <companies-visibility-bar
            :company="company"
            @saved="$emit('saved')"
            v-if="$_can('companies.review.request')"
          />
          <button type="button"
                  class="btn btn-primary ld-ext-right ml-5"
                  @click="saveProfile"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="buttonDisabled"
          >
            Save
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="l-header-2">
          Website details
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <p class="description-text">Information you add here will be visible on Mod24 website for your company.</p>

        <div class="website-details-info-text">
          Set up your company profile that will be to potential customers on Mod24 website. You can chose to remove your visibility by clicking Cancel visibility button. if you need further assistance, please contact us on <b>hello@mod24.com</b>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label class="switch" @click="toggleModBooking()">
          <input type="checkbox"
                 :checked="company.use_mod_booking"
          />
          <span class="check-slider round" />
        </label>
        <span>Use Mod24 booking flow only</span>
        <br />
        <small v-if="company.use_mod_booking">
          Booking URL: https://mod24.com/company-info/{{ company.slug }}
        </small>
      </div>
    </div>

    <div class="row p-3">
      <div class="col-2 mr-0 pr-0 col-square-upload" v-if="$_can('companies.images.store')">
        <FilesUpload :label="'<u>Browse</u> or drag<br> logo photo to upload'"
                     :src="company.logo"
                     :type-id="3"
                     :model="'companies'"
                     :model-id="company.id"
                     :recommended="'Recommended size is 200x200'"
                     ref="refLogoUpload"
                     @update="loadCompany"
        />
      </div>
      <div class="col col-textarea-upload" v-if="$_can('companies.update')">
        <div class="select-wrap">
          <label>Company description</label>
          <textarea class="form-control select-wrap-textarea cd-textarea"
                    placeholder="Enter company description"
                    v-model="company.description" cols="20" rows="7"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="l-header-2">GALLERY</div>
      </div>
    </div>
    <div class="row mb-5" v-if="$_can('companies.images.store')">
      <div class="col-12 col-sm-12 col-md-2">
        <FilesUploadGallery :label="'<u>Browse</u> or drag<br> photo to upload'"
                            :type-id="5"
                            :style-class="'square-upload'"
                            :model="'companies'"
                            :model-id="company.id"
                            ref="refGalleryUpload"
                            @update="loadCompany"
        />
      </div>

      <template class="gallery-div" v-if="sortedImages">
        <div class="col-12 col-sm-12 col-md-2" v-for="image in sortedImages" :key="image.id">
          <div
            :id="image.id"
            :style="{backgroundImage: `url(${image.url})` }"
            style="background-size: cover;background-position:center; position: relative;border-radius: 2px; outline: none;"
            class="square-upload d-inline-block"
          >
            <div class="gallery-img-overlay">
              <div class="img-delete" @click="deleteImage(image)"><img src="../../../assets/img/gallery-close.svg" /></div>
              <div class="image-position-change">
                <span @click="moveImageLeft(image.order)" style="width:100%"><img src="../../../assets/img/gallery-arrow.svg" class="gallery-left" /></span>
                <span class="button-line" />
                <span style="width:100%" @click="moveImageRight(image.order)">
                  <img src="../../../assets/img/gallery-arrow.svg" class="gallery-right" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapActions, mapMutations, mapState } from 'vuex';
import _ from 'lodash';
import Errors from '../../../classes/Errors';
import CompaniesStepsMenu from '../CompaniesStepsMenu';
import FilesUpload from '../../FilesUpload';
import CompaniesVisibilityBar from '../CompaniesVisibilityBar';
import FilesUploadGallery from '../../FilesUploadGallery';

export default {
  components: {
    CompaniesStepsMenu,
    CompaniesVisibilityBar,
    FilesUpload,
    FilesUploadGallery,
  },
  props: {
    type: {
      type: String,
      default: 'edit',
    },
  },
  data: () => ({
    buttonDisabled: false,
    errors: new Errors(),
    loadingButton: false,
    selectedItem: null,
    showSubscriptionModal: false,
    showTooltipPrefix: false,
    timeout: false,
  }),
  computed: {
    ...mapState({
      company: state => state.companies.company,
    }),
    filteredImages() {
      return this.company.images ? this.company.images.filter(el => el.type_id === 5) : null;
    },
    sortedImages() {
      return _.orderBy(this.filteredImages, ['order'], ['asc']);
    },
  },
  methods: {
    ...mapActions(['getCompanies']),
    ...mapMutations(['setCompanyStep', 'setCompany']),
    deleteImage(imageForDeletion) {
      let images = this.company.images.filter(el => el.type_id === 5);
      images = images.filter(image => {
        return image.id !== imageForDeletion.id;
      });
      this.company.images = images;
      axios.delete(`companies/${this.$route.params.id}/images/${imageForDeletion.id}`);
    },
    loadCompany() {
      axios
        .get(`companies/${this.$route.params.id}`)
        .then(res => {
          this.setCompany(res.data.data);
        })
        .then(() => {
          this.$refs.refLogoUpload.afterQueueComplete();
          // this.$refs.refGalleryUpload.afterQueueComplete()
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    moveImageLeft(order) {
      this.company.images = this.sortedImages.map(image => {
        if (order === image.order) {
          image.order -= 1;
          return image;
        }
        if (order - 1 === image.order) {
          image.order += 1;
          return image;
        }
        return image;
      });
      // timeout set not to send to many requsts
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = false;
      } else {
        this.timeout = setTimeout(() => {
          axios
            .put(`companies/${this.$route.params.id}/images`, {
              images: this.company.images,
            })
            .then(() => {
              this.timeout = true;
            });
        }, 1500);
      }
    },
    moveImageRight(order) {
      this.company.images = this.sortedImages.map(image => {
        if (order === image.order) {
          image.order += 1;
          return image;
        }
        if (order + 1 === image.order) {
          image.order -= 1;
          return image;
        }
        return image;
      });
      // timeout set not to send to many requsts
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = false;
      } else {
        this.timeout = setTimeout(() => {
          axios
            .put(`companies/${this.$route.params.id}/images`, {
              images: this.company.images,
            })
            .then(() => {
              this.timeout = true;
            });
        }, 1500);
      }
    },
    openChangeSubscriptionModal() {
      axios
        .get('mod-tiers')
        .then(res => {
          this.modTiers = res.data.data;
          this.showSubscriptionModal = true;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    saveProfile() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      axios
        .patch(`companies/${this.$route.params.id}`, {
          description: this.company.description,
          meta_description: this.company.meta_description,
          meta_title: this.company.meta_title,
        })
        .then(response => {
          this.setCompany(response.data.data);
          toastr.success('Successfully saved');
          this.errors.clear();
          this.getCompanies();
          this.$emit('saved');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    toggleModBooking() {
      axios
        .patch(`companies/${this.company.id}`, {
          use_mod_booking: !this.company.use_mod_booking,
        })
        .then(() => {
          this.loadCompany();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
  },
};
</script>
<style scoped>
.square-upload:first-child {
  border: none;
  margin: 0 auto;
  outline: 1px dashed lightgrey;
}

.gallery-div {
  position: relative;
  height: 100%;
  width: 100%;
}
.cd-textarea {
  height: 175px;
}
.col-12.col-sm-12.col-md-2 {
  max-width: 200px;
  margin-right: 5px;
}
.gallery-img-overlay:hover {
  opacity: 1;
  background: rgba(144, 144, 144, 0.3);
}
.gallery-img-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  transition: 0.3s ease;
  max-width: 200px;
  max-height: 200px;
}
.img-delete {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.image-position-change {
  position: absolute;
  bottom: 8px;
  right: 8px;
  text-align: center;
  width: 64px;
  height: 32px;
  object-fit: contain;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.img-delete:hover,
.image-position-change:hover {
  background-color: #fff;
}
/*.gallery-left{*/
/*  object-fit: contain;*/
/*  position: absolute;*/
/*  top: 50%;*/
/*  transform: translateY(-50%);*/

/*}*/
.gallery-right {
  transform: rotate(180deg);
}

.button-line {
  /*width: 2px;*/
  height: 100%;
  opacity: 0.1;
  border: solid 1px #212529;
  /*margin: 0px 10px;*/
}

.description-text {
  margin-top: 15px;
  margin-left: 15px;
  width: 50%;
  font-size: 0.8rem;
}

.website-details-info-text {
  border: 2px dashed #ba6ad7;
  background-color: #f6eef9;
  padding: 15px;
  border-radius: 5px;
  color: #ba6ad7;
  margin-top: 20px;
  margin-bottom: 15px;
  max-width: 1100px;
}
</style>



// WEBPACK FOOTER //
// src/components/companies/mod24settings/CompaniesProfile.vue